import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { searchCraftAPI } from "../../../api/service";

const INITIAL_STATE = {
  response: null,
  loading: false,
  error: null,
  status: "idle",
} as any;

export const _createRecord = createAsyncThunk(
  "api/craftmanagement/createRecordSlice",
  searchCraftAPI.createRecord
);

export const createRecordSlice = createSlice({
  name: "createRecordSlice",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(_createRecord.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(_createRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.response = action.payload.data;
        state.status = "succeeded";
      })
      .addCase(_createRecord.rejected, (state, action) => {
        state.loading = false;
        state.response = null;
        state.error = action.payload;
        state.status = "failed";
      });
  },
});
